'use client';

import RefreshIcon from '@mui/icons-material/Refresh';
import { Button } from '@mui/material';
import { FC, useCallback } from 'react';
import { Control, FieldValues, SubmitHandler, UseFormReset, useFormState } from 'react-hook-form';

import { useTranslations } from '../../../../hooks/use-translations';

type SubmitButtonStateProps = {
  control: Control<any>;
  textSearch?: string;
  textRefresh?: string;
  initialFetch?: boolean;
  onRefresh(): void;
};

/**
 * Обертка над функцией Submit.
 * После Submit сбрасывает состояние формы
 */
export const onSubmitWrapper =
  <TFieldValues extends FieldValues>(
    onSubmit: SubmitHandler<TFieldValues>,
    reset: UseFormReset<TFieldValues>
  ): SubmitHandler<TFieldValues> =>
  (value) => {
    try {
      onSubmit(value);
    } finally {
      reset(value);
    }
  };

export const SubmitButtonState: FC<SubmitButtonStateProps> = (props) => {
  const { control, textSearch, textRefresh, initialFetch = true, onRefresh } = props;

  const { isDirty, submitCount } = useFormState({
    control,
  });

  const t = useTranslations('buttons');

  const handleRefresh = useCallback(() => {
    onRefresh();
  }, [onRefresh]);

  const isSearch = isDirty || (!initialFetch && submitCount === 0);

  return (
    <Button
      type={isSearch ? 'submit' : 'button'}
      sx={{ marginTop: '29px', height: '45px' }}
      endIcon={!isSearch && <RefreshIcon />}
      onClick={isSearch ? undefined : handleRefresh}
    >
      {isSearch ? (textSearch ?? t('search')) : (textRefresh ?? t('refresh'))}
    </Button>
  );
};
